import { DatatableColumnModel } from '../models/datatable/datatable-column.model';

export const /** @type {?} */ DatatableColumnTemplates = {
  defaultTemplate: {
    property: new DatatableColumnModel({
      display: true,
      disable: false,
      name: '',
      width: '',
      headerAlignment: 'start',
      cellAlignment: 'start',
      sortBy: ''
    }),
    style: {}
  }
}
